import Vue from 'vue';
import { getUserSetting, saveUserSetting } from '@/services/UserSettingsService';

/**
 * Gets the saved page size preference for a given setting key.
 * Returns the saved value or the default size if no preference exists.
 */
export function getPageSizePreference(_vm: Vue, settingKey: string, defaultSize: number): number {
    const saved = getUserSetting(settingKey);
    if (saved) {
        const parsed = parseInt(saved, 10);
        if (!isNaN(parsed) && parsed > 0) return parsed;
    }
    return defaultSize;
}

/**
 * Saves a page size preference to user settings.
 */
export function savePageSizePreference(_vm: Vue, settingKey: string, size: number): void {
    saveUserSetting(settingKey, size.toString());
}
